import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IUpdateNoteInterventionRequestAction {
  data: {
    archived: boolean;
    id: number;
    text: string;
  };
  functions: {
    close: () => void;
    error: (err: any) => void;
  };
}

function updateNoteRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IUpdateNoteInterventionRequestAction>,
) {
  draft.updateNote.config.isLoading = true;
}

export default updateNoteRequest;
